<template>
  <main class="page page-products product wall">
    <section class="product-categories">
      <nav class="product-navigation">
        <ul class="product-navigation__list" v-if="collections">
          <li class="product-navigation__item"
            @click="toggleClass('content-active', 'content-transition', 500)"
          >
            <router-link active-class="product-navigation__link--active" class="product-navigation__link"
              exact
              :to="{ name: 'Products' }"
            >All Products</router-link>
          </li>
          <li class="product-navigation__item"
            v-for="collection in collections"
            :key="collection.id"
            @click="toggleClass('content-active', 'content-transition', 500)"
          >
            <router-link active-class="product-navigation__link--active" class="product-navigation__link"
              :to="{ name: 'Product Collection', params: { id: collection.id }, title: collection.title }"
            >{{ collection.title }}</router-link>
          </li>
        </ul>

        <ul class="product-navigation__list" v-else>
          <template v-for="i in 5">
            <li class="product-navigation__item"
              :key="'placeholder-' + i"
            >
              <span class="product-navigation__pleceholder"></span>
            </li>
          </template>
        </ul>
      </nav>
    </section>

    <section class="content" id="content">
      <template v-if="products && products.length > 0">
        <div class="content-wrap">
          <div class="product-track iscroll" id="iscroll-product">
            <div class="product-track-wrap">

              <page-toolbar
                :collectionsMenuItems="collections"
                :pageHeadline="collectionName"
                :editMenuItems="[
                  {
                    text: 'Images',
                    url: '#'
                  },
                  {
                    text: 'Title',
                    url: '#'
                  },
                  {
                    text: 'Price',
                    url: '#'
                  },
                  {
                    text: 'Sale Price',
                    url: '#'
                  },
                  {
                    text: 'Variants',
                    url: '#'
                  },
                  {
                    text: 'Collections',
                    url: '#'
                  },
                  {
                    text: 'Description',
                    url: '#'
                  }
                ]"
                :moreMenuItems="[
                  [
                    {
                      text: 'Share Collection',
                      share: shareData
                    },
                    {
                      target: '_parent',
                      text: 'Edit Collection in Shopify',
                      url: collectionUrlEdit
                    },
                    {
                      target: '_blank',
                      text: 'View Live Collection',
                      url: collectionUrlView
                    },
                    {
                      target: '_blank',
                      text: 'Sales By Product Report',
                      url: salesByProductUrl
                    }
                  ],
                  $moreLinks
                ]"
                :shareButtonData="shareData"
                :showPageHeadline="true"
              />

              <page-headline :text="`${collectionName}`" />

              <product-filters
                :activeCollection="collectionName"
                :collections="collections"
                :collectionsMenuItems="collections"
                :dateRangeFilterChangeHandler="dateFilter"
                :dateRangeFilterRange="filterDateRange"
                :dateRangeFilterSelectedRange="selectedDateRange"
                :filtersActive="filtersActive"
                :isDashboardVisible="isDashboardVisible"
                :isFiltersVisible="isFiltersVisible"
                :shareButtonData="shareData"
                :shareData="shareData"
                @scrollToggle="scrollToggle"
                @toggleDashboard="toggleDashboard"
                @toggleFilters="toggleFilters"
              />

              <template v-if="filtersActive && !isScrolled">
                <section :class="`tags`">
                  <ActiveFiltersList :activeFilters="filtersActive" />
                </section>
              </template>

              <product-dashboard :dashboards="dashboards" v-if="isDashboardVisible"/>

              <article class="products" v-if="products">
                <menu class="product-sort" v-if="sortTabs">
                  <ul class="product-sort__list">
                    <li class="product-sort__item"
                      v-for="tab in sortTabs"
                      :key="tab"
                      :class="tab == sortActive ? sortActiveClass : ''"
                    >
                      <a href="#" class="product-sort__link"
                        :class="!sortAllow(tab) ? 'product-sort__link--disabled' : ''"
                        @click.prevent="sortProducts"
                        :data-key="tab"
                      >
                        {{ capitalizeFirstLetter(tab) }}
                        <svg-icon-caret-down v-if="tab == sortActive && sortDirection != 'asc'" height="10" width="10" />
                        <svg-icon-caret-up v-if="tab == sortActive && sortDirection == 'asc'" height="10" width="10" />
                      </a>
                    </li>
                  </ul>

                  <span class="product-sort__total"
                    v-if="productsTotal">
                    <span class="product-sort__total-value">{{ productsTotal }}</span>
                    <span class="product-sort__total-label">Products Found</span>
                  </span>
                </menu>


                <div class="empty-products" v-if="products[0].empty">
                  <div class="empty-products__wrapper">
                    <h2 class="empty-products__title">Sorry, no results found.</h2>
                    <a @click="clearFilters()" class="empty-products__clear">Clear All Filters</a>
                  </div>
                </div>

                <ul class="products__list" v-else>
                  <template v-for="(product, index) in products">
                    <keep-alive :key="product.id">
                      <product-tile
                        :key="product.id"
                        :compareAtPrice="product.compare_at_price"
                        :hot="true"
                        :hover="true"
                        :id="product.id"
                        :image="product.image"
                        :inventory="product.inventory"
                        :menu="true"
                        :platformUrl="product._links.platform_url.href"
                        :platformAdminUrl="product._links.platform_admin_url.href"
                        :price="product.price"
                        :published="product.published"
                        :scrollmagic="true"
                        :title="product.title"
                        :totalSales="product.total_sales"
                        :totalVariants="product.total_variants"
                        :unitsSold="product.units_sold"
                        :vendor="product.vendor"
                        @loadProductDetail="updateProductRoute"
                      ></product-tile>
                    </keep-alive>

                    <li class="products__item products__item--promo products__item--hover"
                      v-if="index == 1 && promotion"
                      :class="{ 'scrollmagic__fade-in-up': !$firefox }"
                      :key="'promotion-' + index"
                    >
                      <a class="products__link">
                        <div class="products-image">
                          <div class="products__image" :style="{ backgroundImage: 'url(/static/temp/promo.jpg)' }"></div>
                        </div>
                        <div class="products-info">
                          <h2 class="products__title">Sponsored</h2>
                        </div>
                      </a>
                    </li>
                  </template>
                </ul>
                <SpinningWheel v-if="showSpinningWheel" />
              </article>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <section class="content-loader">Loading...</section>
      </template>
    </section>

    <product-detail
      :id="productDetailId"
      v-on:reset="updateProductRoute"
    >
    </product-detail>

    <connect
      :integration="gaIntegration"
      :show="gaShow"
      @closed="gaSetShow(false)"
    ></connect>

    <status-bar />
  </main>
</template>

<script>
  import _chunk from 'lodash/chunk'
  import _forEach from 'lodash/forEach'
  import _keyBy from 'lodash/keyBy'
  import _map from 'lodash/map'
  import _orderBy from 'lodash/orderBy'
  import axios from 'axios'
  import IScroll from 'iscroll/build/iscroll-probe'
  import { mapActions, mapMutations, mapState } from 'vuex'

  import ActiveFiltersList from '@/components/ActiveFiltersList'
  import Connect from '@/components/Connect'
  import DashboardTile from '@/components/DashboardTile'
  import CountDownRedirectMessage from '@/components/CountDownRedirectMessage'
  import PageHeadline from '@/components/PageHeadline'
  import PageToolbar from '@/components/PageToolbar'
  import ProductDashboard from '@/components/ProductDashboard'
  import ProductDatePicker from '@/components/ProductDatePicker'
  import ProductDetail from '@/pages/ProductDetail'
  import ProductFilters from '@/components/ProductFilters'
  import ProductTile from '@/components/ProductTile'
  import SpinningWheel from '@/components/SpinningWheel'
  import StatusBar from '@/components/StatusBar'
  import SvgIconCaretDown from '@/svgs/SvgIconCaretDown'
  import SvgIconCaretUp from '@/svgs/SvgIconCaretUp'

  import { helpers } from '@/mixins/helpers.js'
  import { refresh } from '@/mixins/refresh.js'

  import { getProductFilters } from '@/utils/altview/getProductFilters.js'

  export default {
    name: 'products',
    components: {
      ActiveFiltersList,
      'connect': Connect,
      'count-down-redirect-message': CountDownRedirectMessage,
      'dashboard-tile': DashboardTile,
      'page-headline': PageHeadline,
      'page-toolbar': PageToolbar,
      'product-dashboard': ProductDashboard,
      'product-date-picker': ProductDatePicker,
      'product-detail': ProductDetail,
      'product-filters': ProductFilters,
      'product-tile': ProductTile,
      'svg-icon-caret-down': SvgIconCaretDown,
      'svg-icon-caret-up': SvgIconCaretUp,
      'status-bar': StatusBar,
      SpinningWheel
    },
    mixins: [ helpers, refresh ],
    data () {
      return {
        bottom: false,
        collectionId: null,
        collectionName: '',
        collections: null,
        collectionUrlEdit: '',
        collectionUrlView: '',
        dashboards: [],
        filterDateRange: this.$store.state.ui.filterDateRange,
        iscroll: [],
        itemSales: null,
        mobileScrollEvents: false,
        productDetailId: null,
        products: [],
        productsUrl: `${this.$domain}/products`,
        productsNextPage: null,
        productsSalesPage: null,
        productsSalesPages: null,
        progressCompleted: null,
        progressRequests: null,
        productsTotal: null,
        promotion: false,
        refresh_active: false,
        refresh_method: 'loadSalesData',
        selectedDateRange: this.$store.state.ui.selectedDateRange,
        scrollMagicProgress: null,
        sortTabs: [
          'new',
          'title',
          'price',
          'inventory',
          'sales'
        ],
        sortActive: 'new',
        sortActiveClass: 'product-sort__item--active',
        sortDirection: 'desc',
        isDashboardVisible: true,
        isFiltersVisible: false,
        isScrolled: false,
        isProductsPage: true,
        showSpinningWheel: false
      }
    },
    computed: {
      ...mapState(
        'ui',
        {
          filtersActive: 'filtersActiveProductsPage'
        }
      ),
      ...mapState(
        'ga',
        [
          'gaIntegration',
          'gaIsSetup',
          'gaShow'
        ]
      ),
      ...mapState(
        'mockData',
        {
          // filtersActive: 'filtersActiveProductsPage'
        }
      ),
      shareData: function () {
        const shareData = {
          pageHeadline: this.collectionName,
          linkUrl: `https://app.helloseemore.com/`
        }

        return shareData
      },
      salesByProductUrl: function () {
        if (process.env.API_URL.includes('dev.api') || process.env.API_URL.includes('localhost')) {
          const start = this.filterDateRange.start.format('YYYY-MM-DD')
          const end = this.filterDateRange.end.format('YYYY-MM-DD')
          return `https://${this.$domain}/admin/reports/sales_by_product_name?startDate=${start}&endDate=${end}`
        }

        return null
      }
    },
    watch: {
      bottom: function (boolean) {
        if (boolean === true && this.productsNextPage !== null) {
          this.showSpinningWheel = true

          this.loadProducts(true, () => {
            this.showSpinningWheel = false
          })
        }
      },
      filtersActive: function () {
        // when the active filters change, do this
        this.productsNextPage = null
        this.loadData()
      },
      products: function () {
        // Mobile Scroll
        this.scrollEventsMobile()
      },
      '$route.params.id': function (id) {
        this.collectionId = id
        this.setActiveCollection()
        this.productsNextPage = null
        this.loadData(false)
        this.scrollContentToTop()
      },
      '$route.params.productId': function (productId) {
        this.productDetailId = productId
      }
    },
    created () {
      if (this.$route.query && this.$route.query.id) {
        this.updateProductRoute(this.$route.query.id)
      }

      document.querySelector('html').classList.add('scrollmagic-loading')
      this.collectionId = this.$route.params.id
      this.productDetailId = this.$route.params.productId
      this.loadData()
      this.loadGAIntegration(this.$domain)
    },
    mounted () {
      let that = this

      // Desktop Scroll
      window.addEventListener('scroll', () => {
        that.bottom = that.pageBottom()
      })

      window.addEventListener('resize', () => {
        if (that.$ios) {
          that.scrollMagicUpdate()
        }
      })
    },
    methods: {
      ...mapActions(
        'ga',
        [
          'loadGAIntegration'
        ]
      ),
      ...mapMutations(
        'ga',
        [
          'gaSetShow'
        ]
      ),
      ...mapMutations(
        'ui',
        [
          'filterDateRangeAssign',
          'selectedDateRangeAssign',
          'saveSelectedDateRange',
          'filtersActiveProductsPageRemoveAll'
        ]
      ),
      ...mapMutations(
        'shop',
        [
          'hasMultipleVendorsAssign'
        ]
      ),
      toggleFilters (isVisible) {
        this.isFiltersVisible = !this.isFiltersVisible
      },
      scrollToggle (isVisible) {
        if (isVisible === false) {
          this.isFiltersVisible = false
        } else {
          this.isFiltersVisible = true
        }
      },
      toggleDashboard () {
        this.isDashboardVisible = !this.isDashboardVisible
      },
      applyParams (params, includeDates) {
        // Collection filtering
        if (this.collectionId) {
          params['collection_id'] = this.collectionId
        }

        // Date Filtering
        if (includeDates === true) {
          if (this.filterDateRange.end) {
            params['end'] = encodeURI(this.filterDateRange.end.format())
          }
          if (this.filterDateRange.start) {
            params['start'] = encodeURI(this.filterDateRange.start.format())
          }
        }

        // Product filter filtering
        if (this.filtersActive.length) {
          params['product_filter_id'] = Array.prototype.map.call(this.filtersActive, s => s.id).toString()
        }

        return params
      },
      applySales () {
        let that = this

        _forEach(that.products, function (product) {
          if (that.itemSales && that.itemSales.hasOwnProperty(product.id)) {
            product.total_sales = that.itemSales[product.id].total_price
            product.units_sold = that.itemSales[product.id].quantity
          } else {
            product.total_sales = 0
            product.units_sold = 0
          }
        })

        this.iScrollUpdate()
      },
      backButtonCheck () {
        let html = document.querySelector('html')

        if (html.classList.contains('product-detail-active')) {
          html.classList.remove('product-detail-active')
        }

        if (html.classList.contains('content-active')) {
          html.classList.remove('content-active')
        }
      },
      clearFilters (event) {
        this.filtersActiveProductsPageRemoveAll()
      },
      dateFilter (dateRange, selectedDateRange) {
        this.filterDateRangeAssign(dateRange)
        this.selectedDateRangeAssign(selectedDateRange)

        // may be map these to local state
        this.filterDateRange = this.$store.state.ui.filterDateRange
        this.selectedDateRange = this.$store.state.ui.selectedDateRange

        this.loadSalesData()
      },
      isManualSort () {
        return this.sortActive === 'sales'
      },
      iScroll () {
        if (this.$ios) {
          let container = document.querySelector('.content')
          let elements = container.querySelectorAll('.iscroll')
          let iscroll = this.iscroll

          setTimeout(() => {
            for (let element of elements) {
              let id = element.id

              if (iscroll.indexOf(id) === -1) {
                iscroll.push(id)
                iscroll[id] = new IScroll('#' + id, {
                  eventPassthrough: this.getBreakpoint() >= 768,
                  mouseWheel: true,
                  probeType: 3
                })
              }

              iscroll[id].refresh()

              if (id === 'iscroll-product') {
                var debounce

                iscroll[id].on('scroll', () => {
                  // let iscrollTop = iscroll[id].y
                  let el = document.querySelector('.product-track-wrap')
                  let position = Math.round(el.getBoundingClientRect().bottom)
                  let windowHeight = window.innerHeight || document.body.clientHeight

                  clearTimeout(debounce)
                  debounce = setTimeout(() => {
                    if (position === windowHeight && this.productsNextPage !== null) {
                      this.loadProducts()
                    }
                  }, 100)
                })
              }
            }
          }, 500)

          // Resize
          window.addEventListener('resize', () => {
            for (let id of iscroll) {
              iscroll[id].refresh()
            }
          })
        }
      },
      iScrollUpdate () {
        if (this.$ios) {
          setTimeout(() => { this.triggerWindowResize() }, 500)
        }
      },
      getTagTypeFromId (id) {
        let type = null

        // ie.
        // "option.e8ed002412e8" to "option"
        if (id) {
          type = id.split('.')[0]
        }

        return type
      },
      loadCollections () {
        let that = this

        return axios({
          method: 'get',
          url: `${that.$domain}/collections`
        })
        .then((response) => {
          that.collections = _orderBy(response.data.collections, ['title'])
          that.setActiveCollection()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadDashboards () {
        let that = this
        let container = document.querySelector('.product-dashboard')
        let params = that.applyParams({}, true)

        // trigger array update
        that.dashboards = []

        if (container !== null) {
          container.classList.add('dashboard-loading')
        }

        return axios({
          method: 'get',
          url: `${that.$domain}/order_sales_dashboard`,
          params: params
        })
        .then((response) => {
          that.dashboards = response.data.dashboards

          if (container !== null) {
            container.classList.remove('dashboard-loading')
          }
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadData (collections = true) {
        this.$Progress.start()

        let requests = []

        if (this.sortActive !== 'sales') {
          requests.push(this.loadProducts(false))
        }

        requests.push(this.loadSalesData(false))

        if (collections) {
          requests.push(this.loadCollections())
        }

        getProductFilters({ filter_type: 'vendor' }, (productFilters) => {
          const hasMultipleVendors = productFilters.length > 1

          if (hasMultipleVendors) {
            this.hasMultipleVendorsAssign(true)
          } else {
            this.hasMultipleVendorsAssign(false)
          }
        })

        return axios.all(requests)
        .then(axios.spread(() => {
          this.$Progress.finish()
          this.iScrollUpdate()
        }))
        .catch((error) => {
          console.log(error)
          this.$Progress.fail()
        })
      },
      loadProducts (progress = true, callback) {
        let that = this
        let container = document.querySelector('.content .products')
        let params = that.applyParams(that.sortParams())
        let url = that.productsNextPage !== null ? that.productsNextPage : that.productsUrl

        if (params === false) {
          return false
        }

        if (progress) {
          that.$Progress.start()
        }

        if (container !== null && that.productsNextPage === null) {
          container.classList.add('loading--products')
        }

        return axios({
          method: 'get',
          url: url,
          params: params
        })
        .then((response) => {
          let data = response.data

          if (callback && typeof callback === 'function') {
            callback(response.data)
          }

          let results = _forEach(data.products, function (item, index) {
            const {
              // price,
              variant_list: variantList
            } = item

            item.total_sales = 0
            item.units_sold = 0

            if (variantList && Array.isArray(variantList)) {
              item.total_variants = variantList.length
            }
          })

          if (data.pagination.total_items !== null) {
            that.productsTotal = data.pagination.total_items
          }

          if (that.productsNextPage !== null) {
            Array.prototype.push.apply(that.products, results)
            that.loadCollections()
          } else {
            that.products = results
          }

          if (results.length === 0) {
            that.products = [{ empty: true }]
          }

          if (progress) {
            that.$Progress.finish()
          }

          that.scrollMagicUpdate()
          that.applySales()

          if (container !== null && that.productsNextPage === null) {
            container.classList.remove('loading--products')
          }

          if (that.productsSalesPage > 0 && that.productsSalesPage < that.productsSalesPages.length) {
            that.productsNextPage = that.productsUrl
          } else {
            that.productsNextPage = data.pagination._links.next_page.href
          }
        })
        .catch((error) => {
          console.log(error)
          if (progress) {
            that.$Progress.fail()
          }
        })
      },
      loadSales () {
        let that = this
        let params = that.applyParams({
          group_by: 'product_id'
        }, true)

        return axios({
          method: 'get',
          url: `${that.$domain}/item_sales`,
          params: params
        })
        .then((response) => {
          that.itemSales = _keyBy(response.data.item_sales, 'product_id')
          let requests = [that.loadDashboards()]

          if (that.sortActive === 'sales') {
            that.productsSalesPage = 0
            requests.push(that.loadProducts(false))
          } else {
            that.applySales()
          }

          return axios.all(requests)
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSalesData (progress = true) {
        let that = this
        if (progress) {
          that.$Progress.start()
        }

        return this.loadSales()
        .then(() => {
          if (progress) {
            that.$Progress.finish()
            that.iScrollUpdate()
          }
        })
        .catch((error) => {
          console.log(error)
          if (progress) {
            that.$Progress.fail()
          }
        })
      },
      pageBottom () {
        if (this.getBreakpoint() >= 768) {
          let documentHeight = Math.max(
            Math.max(document.body.scrollHeight, document.documentElement.scrollHeight),
            Math.max(document.body.offsetHeight, document.documentElement.offsetHeight),
            Math.max(document.body.clientHeight, document.documentElement.clientHeight)
          )
          let scrollY = window.scrollY
          let windowHeight = window.innerHeight || document.body.clientHeight
          let bottomOfPage = windowHeight + scrollY >= documentHeight

          return bottomOfPage || documentHeight < windowHeight
        }
      },
      pageBottomMobile (e) {
        if (this.getBreakpoint() < 768) {
          let el = e.currentTarget
          let rect = el.getBoundingClientRect()
          let elHeight = el.clientHeight || el.offsetHeight
          let elScrollHeight = el.scrollHeight + (parseInt(rect.height) - rect.height) || el.scrollHeight
          let bottomOfPage = Math.floor(elScrollHeight - el.scrollTop) <= elHeight // Firefox mobile scrollHeight compliant

          this.bottom = bottomOfPage
        }
      },
      resetProductDetail () {
        this.productDetailId = ''
      },
      scrollEventsMobile () {
        if (this.products && this.products.length > 0 && this.mobileScrollEvents === false) {
          this.mobileScrollEvents = true

          setTimeout(() => {
            let el = document.querySelector('.product-track')

            if (el !== null) {
              el.onscroll = this.pageBottomMobile // Not IOS
            }

            this.iScroll() // IOS
          }, 500)
        }
      },
      scrollMagicFadeIn () {
        if (this.$firefox === false) {
          let fadeElements = document.querySelectorAll('.scrollmagic__fade-in-up')
          let html = document.querySelector('html')

          this.scrollMagicProgress = null

          if (this.$ScrollMagicEvent !== null) {
            for (let fadeElement of fadeElements) {
              let scene = new this.$ScrollMagic.Scene({
                triggerElement: fadeElement,
                triggerHook: 0.95,
                reverse: false
              })
              .setClassToggle(fadeElement, 'scrollmagic__fade-in-up--show')
              // .addIndicators() // Debug tool for scrollmagic

              this.$ScrollMagicEvent.$emit('addScene', 'scrollMagicFadeIn', scene)

              this.scrollMagicProgress = scene.progress()
            }
          }

          if (html.classList.contains('scrollmagic-loading')) {
            html.classList.remove('scrollmagic-loading')
          }
        }
      },
      scrollMagicFadeInDestroy () {
        if (this.$firefox === false) {
          let items = document.querySelectorAll('.scrollmagic__fade-in-up')

          for (let item of items) {
            if (item.classList.contains('scrollmagic__fade-in-up--show')) {
              item.classList.remove('scrollmagic__fade-in-up', 'scrollmagic__fade-in-up--show')
            }
          }

          this.$ScrollMagicEvent.$emit('destroy')
        }
      },
      scrollMagicUpdate () {
        if (this.$firefox === false) {
          this.scrollMagicFadeInDestroy()

          let scrollMagicReady = setInterval(() => {
            this.scrollMagicFadeIn()

            if (this.scrollMagicProgress !== null) {
              clearInterval(scrollMagicReady)
            }
          }, 100)
        }
      },
      scrollContentToTop () {
        if (this.getBreakpoint() < 768) {
          let container = document.querySelector('.product-track')
          if (container !== null) {
            container.scrollTop = 0
          }
        } else {
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
        }

        // IOS
        let iscroll = this.iscroll
        for (let id of iscroll) {
          iscroll[id].scrollTo(0, 0)
        }
      },
      setActiveCollection () {
        this.collectionName = 'All Products'

        if (this.collectionId && this.collections) {
          let collections = _keyBy(this.collections, 'id')
          const {
            _links,
            title
          } = collections[this.collectionId]

          this.collectionName = title
          this.collectionUrlEdit = _links.platform_admin_url ? _links.platform_admin_url.href : null
          this.collectionUrlView = _links.platform_url ? _links.platform_url.href : null
        } else {
          this.collectionUrlEdit = null
          this.collectionUrlView = null
        }
      },
      sortAllow (key) {
        if (key === 'sales') {
          return this.itemSales && Object.keys(this.itemSales).length > 0
        }

        return true
      },
      sortParams () {
        // For sales sorting, return specific product object_ids in order
        if (this.sortActive === 'sales') {
          if (this.sortAllow(this.sortActive)) {
            // Get a list of product object_ids in the right order
            let productIds = _map(this.itemSales, 'product_id')
            if (this.sortDirection === 'asc') {
              productIds = productIds.reverse()
            }

            // Paginate product_ids
            let count = 25
            this.productsSalesPages = _chunk(productIds, count)
            let products = this.productsSalesPages[this.productsSalesPage]
            this.productsSalesPage++

            return {
              'object_ids': products.join(',')
            }
          } else {
            this.sortActive = this.sortTabs[0]
          }
        }

        // Standard sorting by key and direction
        return {
          'sort_by': `${this.sortActive}_${this.sortDirection}`
        }
      },
      sortProducts (e) {
        let key = e.currentTarget.dataset.key
        let parent = e.currentTarget.closest('li')
        let active = parent.classList.contains(this.sortActiveClass)
        let direction = 'desc'

        if (!this.sortAllow(key)) {
          return false
        }

        // If already active toggle sort direction
        if (active) {
          direction = this.sortDirection === 'desc' ? 'asc' : 'desc'
        }

        this.sortActive = key
        this.sortDirection = direction
        this.productsNextPage = null
        this.productsSalesPage = 0
        this.productsSalesPages = null
        this.loadProducts()
      },
      /**
       * Dynamically update the route based on current collection and passed productId
       */
      updateProductRoute (productId = null) {
        let params = {}

        if (productId) {
          params.productId = productId
        }

        // If we are on a collection load product collection detail or collection page
        if (this.$route.params.id) {
          params.id = this.$route.params.id
          if (productId) {
            // this.$router.push({name: 'Product Collection Detail', params: params})
            this.$router.push({name: 'Product Detail', params: params})
          } else {
            this.$router.push({name: 'Product Collection', params: params})
          }
        // If product id load product detail
        } else if (productId) {
          this.$router.push({name: 'Product Detail', params: params})
        // Otherwise load all products
        } else {
          this.$router.push({name: 'Products'})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/Products.vue